import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TEmExportsApi } from './types';

/** The name the file has to be saved with, e.g. `attachment; filename="orders_2026.csv"`. */
const getFileNameFromContentDisposition = (contentDisposition?: string): string | null => {
	if (!contentDisposition) return null;

	const encodedName = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
	if (encodedName) return decodeURIComponent(encodedName[1]);

	const name = /filename="?([^";]+)"?/i.exec(contentDisposition);
	return name ? name[1].trim() : null;
};

export const emExports: TEmExportsApi = {
	exportOrders: (payload) =>
		http.post(endpoint.emExports.EXPORT_ORDERS, payload).then((response) => response.data),
	exportReturns: (payload) =>
		http.post(endpoint.emExports.EXPORT_RETURNS, payload).then((response) => response.data),
	downloadEmExportFile: (payload) =>
		http
			.get(endpoint.emExports.DOWNLOAD_FILE(payload.hash), { responseType: 'blob' })
			.then((response) => ({
				file: response.data as Blob,
				fileName:
					getFileNameFromContentDisposition(
						response.headers['content-disposition'] as string | undefined,
					) ?? 'export',
			})),
};
